(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('CurrencyJournalSearch', CurrencyJournalSearch);

    CurrencyJournalSearch.$inject = ['$resource'];

    function CurrencyJournalSearch($resource) {
        var resourceUrl =  'api/_search/currency-journals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
